import { DisclosureButton, DisclosurePanel } from '@reach/disclosure';
import { StyledButton } from 'components/button';
import { rem, size } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: ${rem(20)} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.palette.grey};

  &:last-child {
    border-bottom: 0;
  }
`;

interface InitialValuesWrapperProps {
  isOpen?: boolean;
}

export const InitialValuesWrapper = styled.div<InitialValuesWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ isOpen }) => (isOpen ? rem(20) : 0)};

  h2 {
    margin-bottom: 0;
  }
`;

export const InitialValues = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: minmax(30%, 0.5fr) 1fr;

  > * {
    display: inline-block;
    margin: 0 ${rem(1)};
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledDisclosureButton = styled(DisclosureButton)`
  flex-shrink: 0;
  margin-left: auto;
  background: none;
  border: 0;
  cursor: pointer;

  svg {
    ${size(rem(20))}

    display: block;
    color: ${({ theme }) => theme.colors.palette.black};

    &:hover {
      color: ${({ theme }) => theme.colors.palette.redDark};
    }
  }
`;

export const StyledDisclosurePanel = styled(DisclosurePanel)`
  ${StyledButton} {
    width: 100%;
    max-width: 100%;
    margin-top: ${rem(20)};
  }
`;

export const EditToggleGroup = styled.div`
  margin: ${rem(30)} 0;
  padding: ${rem(30)};
  overflow: hidden;
  color: ${({ theme }) => theme.colors.palette.black};
  background-color: ${({ theme }) => theme.colors.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;
